import React, { useContext, useMemo, useEffect } from "react";
import { APP_PAGE, actions } from "../../hooks/useAppState";
import useNotifications from "../../hooks/useNotifications";
import useT from "../../hooks/useT";
import Button from "../../components/Button";
import Page from "../../components/Page";
import Notification from "../../components/Notification";
import AppLayout from "../../containers/AppLayout";
import { AppStateContext } from "../App";
import "./ActionsPage.css";
import { useServiceWorker } from "../../hooks/useServiceWorker";
import { getConfigValue } from "../../config";
import {
  setIsRemote,
  setCustomerDataState
} from "../../hooks/useCustomerDataState";

export default function ActionsPage() {
  const { t } = useT();
  const [appState, doAppStateAction] = useContext(AppStateContext);
  const { checkNotifications, notificationsStore } = useNotifications();
  const { isUpdateAvailable, updateAssets } = useServiceWorker();
  const config = appState.config;

  // Memoised values
  const lastUnreadNotification = useMemo(
    () => notificationsStore.getByProp("read", false),
    [checkNotifications]
  );

  useEffect(() => {
    if (isUpdateAvailable) {
      updateAssets();
    }
  }, [isUpdateAvailable]);

  let enableRemote = getConfigValue(
    appState.zone,
    "customise.customer.enableRemoteCustomer"
  );
  const remoteTheme =
    getConfigValue(
      appState.zone,
      "customise.actions.remoteCustomerButtonTheme"
    ) || "neutral";
  const enableHistory = getConfigValue(
    appState.zone,
    "customise.history.enable"
  );

  return (
    <AppLayout>
      {lastUnreadNotification && !lastUnreadNotification.read && (
        <Notification
          {...lastUnreadNotification}
          onClose={event => {
            event.preventDefault();
            notificationsStore.markReadById(lastUnreadNotification.id);
          }}
        />
      )}
      <Page name="actions" title={t("actions.page.title")}>
        <ul className="actions-list">
          <li className="actions-list-item action-create-customer">
            <Button
              label={t("actions.createCustomer.label")}
              theme="primary"
              onClick={event => {
                event.preventDefault();
                setIsRemote(false);
                setCustomerDataState({});
                doAppStateAction(actions.setPage(APP_PAGE.CUSTOMER));
              }}
              className="buttonActionList"
            />
          </li>
          {enableRemote && (
            <li className="actions-list-item action-search-customer">
              <Button
                label={t("actions.remoteCustomer.label")}
                theme={remoteTheme}
                onClick={event => {
                  event.preventDefault();
                  setCustomerDataState({});
                  setIsRemote(true);
                  doAppStateAction(actions.setPage(APP_PAGE.CUSTOMER));
                }}
              />
            </li>
          )}
          {config.customise.searchCustomer.enable && (
            <li className="actions-list-item action-search-customer">
              <Button
                label={t("actions.searchCustomer.label")}
                theme="primary"
                onClick={event => {
                  event.preventDefault();
                  doAppStateAction(actions.setPage(APP_PAGE.SEARCH));
                }}
              />
            </li>
          )}
          {enableHistory && (
            <li className="actions-list-item action-search-customer">
              <Button
                label={t("actions.customersHistory.label")}
                theme="primary"
                onClick={event => {
                  event.preventDefault();
                  doAppStateAction(actions.setPage(APP_PAGE.HISTORY));
                }}
              />
            </li>
          )}
        </ul>
      </Page>
    </AppLayout>
  );
}
